/**
 * Reusable shimmer skeleton placeholder.
 * Uses the existing @keyframes shimmerOrange from index.css.
 */
export default function Skeleton({
  width = '100%',
  height = '1rem',
  borderRadius = '6px',
  count = 1,
  gap = '1rem',
  style = {},
}) {
  const baseStyle = {
    width,
    height,
    borderRadius,
    background: 'linear-gradient(90deg, var(--bg-card) 25%, var(--border) 50%, var(--bg-card) 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmerOrange 1.5s infinite',
    border: '1px solid var(--border)',
    ...style,
  };

  if (count <= 1) return <div style={baseStyle} />;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap }}>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} style={baseStyle} />
      ))}
    </div>
  );
}
